import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'extractFormValue'
})
export class ExtractFormValuePipe implements PipeTransform {

  transform(item: any, args?: any): any {
    let result = '';
    try {
      result = args.value(item);
    } catch (e) {
      result = '';
    }

    return result;
  }

}
